import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://p0oswcss8sggs44c8g0gsw00.72.60.250.39.sslip.io",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("❌ Erro na API:", {
      status: error.response?.status,
      message: error.message,
      code: error.code,
      url: error.config?.url,
    });

    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || "";
      const isLoginRequest = requestUrl.includes("/usuario/login");

      if (!isLoginRequest) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
    } else if (error.response?.status === 502) {
      console.error("Bad Gateway - Servidor backend não está respondendo");
    } else if (error.code === "ECONNABORTED") {
      console.error("Timeout - Servidor demorou para responder");
    } else if (error.code === "ERR_NETWORK") {
      console.error("Erro de rede - Verifique sua conexão");
    }

    return Promise.reject(error);
  }
);

export default api;
